import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export var useGetTaskPeriodicity = function (taskTemplateId) {
    var intl = useIntl();
    var _a = useQuery([TaskQueryKey.TaskPeriodicity, taskTemplateId], function () {
        return taskTemplateId
            ? api.base
                .get("".concat(config.appUrls.tasks, "/api/TaskPeriodicity/").concat(taskTemplateId))
                .then(function (res) { return res.data; })
            : null;
    }, {
        enabled: true,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error, refetch = _a.refetch;
    return {
        data: data,
        error: error,
        isLoading: isLoading,
        refetch: refetch,
    };
};
